import type { JSX } from 'react';
import type { SurfaceOf } from './types';
import { useSurfaceActions } from './context';
import { useT } from '../i18n/useT';

export function SlotPickerSurfaceView({ surface }: { surface: SurfaceOf<'slot-picker'> }): JSX.Element {
  const t = useT();
  const actions = useSurfaceActions();
  return (
    <section className="surface surface-slots">
      <h3 className="surface-title">{surface.title}</h3>
      {surface.selectionPrompt ? <p className="muted small">{surface.selectionPrompt}</p> : null}
      {surface.slots.length === 0 ? <p className="muted">{t('none')}</p> : null}
      <div className="slot-grid">
        {surface.slots.map((s, i) => (
          <button key={`${s.providerId}-${s.start}`} type="button" className="btn slot" onClick={() => actions.pickSlot(s)} aria-label={`${t('pickSlot')} ${i + 1}: ${s.localDate} ${s.localTime}`}>
            <span className="slot-index">{i + 1}</span>
            <span className="slot-date">{s.localDate}</span>
            <strong className="slot-time">{s.localTime}</strong>
            <span className="muted small">{s.providerName ?? s.providerId}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
